module.exports = __webpack_public_path__ + "img/arrow-2.418a1b6b.png";